import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SubMenu = ({name, children}) => { 
    return (
        <div className="sub-menu menu-item">
          <div className="sub-menu-name">
            {name}
          </div>
          <div className="arrow-right"/>
          <div className="sub-menu-children">
            {children}
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);
